import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import store from 'store';
import { IApplicationState } from '../store/state/app-state';
import { Ability, RawRule } from '@casl/ability';

const storeData: IApplicationState = store.getState();
const abilities: RawRule[] = storeData.UserData ? storeData.UserData.abilities : [];

const AbilityContext = createContext(null);
const Can = createContextualCan(AbilityContext.Consumer);

export { AbilityContext, Can };
export default new Ability(abilities);
